import { supabase } from "../supabaseClient"

const invoke = async (body) => {
  const { data, error } = await supabase.functions.invoke("account-audits", { body })
  if (error) {
    let payload = null
    if (error.context?.json) {
      try { payload = await error.context.json() } catch (_) {
        // Preserve the function client's error.
      }
    }
    const requestError = new Error(payload?.error || error.message || "Account Audits request failed")
    requestError.code = payload?.code || null
    throw requestError
  }
  if (data?.error) throw new Error(data.error)
  return data || {}
}

export const loadAccountAuditWorkspace = (organizationId, accountId) => invoke({
  action: "load-workspace", organization_id: organizationId, account_id: accountId || null,
})

export const saveAccountAuditProfile = (organizationId, accountId, profile) => invoke({
  action: "save-profile", organization_id: organizationId, account_id: accountId, ...profile,
})

export const changeAccountAuditAssignment = (organizationId, accountId, platform, assetId, assigned) => invoke({
  action: assigned ? "assign-asset" : "unassign-asset",
  organization_id: organizationId, account_id: accountId, platform, asset_id: assetId,
})

export const startAccountAuditRun = (organizationId, accountId, dateRangeDays) => invoke({
  action: "start-run", organization_id: organizationId,
  account_id: accountId, date_range_days: dateRangeDays,
})

export const auditAccountAsset = (organizationId, runId, asset) => invoke({
  action: "audit-asset", organization_id: organizationId, run_id: runId,
  platform: asset.platform, asset_id: asset.asset_id,
})

export const finalizeAccountAuditRun = (organizationId, runId) => invoke({
  action: "finalize-run", organization_id: organizationId, run_id: runId,
})

export const loadAccountAuditRun = (organizationId, runId) => invoke({
  action: "get-run", organization_id: organizationId, run_id: runId,
})

export const startGoogleAdsAuditOAuth = (organizationId) => invoke({
  action: "google-ads-oauth-start", organization_id: organizationId,
})

export const completeGoogleAdsAuditOAuth = (organizationId, code, state) => invoke({
  action: "google-ads-oauth-complete", organization_id: organizationId, code, state,
})
